export const useStyles = (theme) => ({
  root: {
    padding: 10,
  },
  mainBrowse: {
    width: "100%",
    display: "flex",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    justifyContent: "center",
    alignItems: "center",
  },
  titleButtonStyle: {
    background: "#0a1f3a !important",
    outlineColor: "#0a1f3a !important",
    color: "#ffffff",
    fontSize: 18,
    borderRadius: 20,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#eee !important",
      borderColor: "#0a1f3a !important",
      color: "#181818",
    },
  },
  publishBook: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    display: "flex",
    paddingLeft: 250,
    [theme.breakpoints.down(960)]: {
      paddingLeft: 0,
    },
  },
  bodyText: {
    fontSize: 30,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down(960)]: {
      paddingLeft: 0,
    },
  },
  gridContainer: {
    padding: 10,
  },
  notificationStyle: {
    top: 80,
    right: 10,
  },
  paginationStyle: {
    padding: 10,
    display: "flex",
    justifyContent: "center",
  },
});
